import { useMutation } from '@tanstack/react-query'

import { requestSendingMetalCard } from '@src/api'
import { DefaultApiRequestSendingMetalCardRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useRequestSendingMetalCard = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiRequestSendingMetalCardRequest) =>
      requestSendingMetalCard(axiosInstance, params),
  })
}
